var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"register__row"},[_c('RegisterSteps',{attrs:{"step":_vm.step,"title":'Обновление профиля',"stepList":_vm.stepList}}),_c('UpdateForm',{on:{"changeStep":_vm.changeStep}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }